import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  connect() {
    this.startedAt = Date.now()
    this.inputTarget.focus()
  }

  key(event) {
    this.inputTarget.value += event.params.key
    this.inputTarget.focus()
  }

  backspace() {
    this.inputTarget.value = this.inputTarget.value.slice(0, -1)
    this.inputTarget.focus()
  }

  stamp(event) {
    if (this.inputTarget.value.trim() === "") {
      event.preventDefault()
      return
    }

    const form = event.target

    const input = document.createElement("input")
    input.type = "hidden"
    input.name = "time_taken_ms"
    input.value = Date.now() - this.startedAt
    form.appendChild(input)
  }
}
